import React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { Office } from '../../models/office';
import { Route } from '../../models/route';
import { useT } from '../../i18n';
import RouteChecklist from './RouteChecklist';

interface Props {
  office_id: string;
  setOffice_id: (value: string) => void;
  offices: Office[];
  collectsOffice: Route[];
  selectedCollects: string[];
  setSelectedCollects: (value: string[]) => void;
  selectAll: boolean;
  setSelectAll: (value: boolean) => void;
  handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelectAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
  /** Marca para el recorrido de la pantalla: `data-tour` `<prefijo>-office` y `<prefijo>-routes`. */
  tourPrefix?: string;
}

/** Elegir una sede y marcar varias de sus rutas. */
const SelectCollectbyOffice: React.FC<Props> = ({
  office_id,
  setOffice_id,
  offices,
  collectsOffice,
  selectedCollects,
  selectAll,
  handleCheckboxChange,
  handleSelectAll,
  tourPrefix,
}) => {
  const t = useT();
  return (
    <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: 'minmax(0, 1fr)', minWidth: 0 }}>
      <TextField
        select
        size="small"
        label={t('common.office')}
        data-tour={tourPrefix ? `${tourPrefix}-office` : undefined}
        value={office_id}
        onChange={(e) => setOffice_id(e.target.value)}
        sx={{ maxWidth: { md: 360 } }}
        fullWidth
      >
        {offices.map((office) => (
          <MenuItem key={office.id} value={String(office.id)}>
            {office.name}
          </MenuItem>
        ))}
      </TextField>
      {office_id && (
        <Box data-tour={tourPrefix ? `${tourPrefix}-routes` : undefined} sx={{ minWidth: 0 }}>
        <RouteChecklist
          routes={collectsOffice}
          selected={selectedCollects}
          selectAll={selectAll}
          onToggle={handleCheckboxChange}
          onToggleAll={handleSelectAll}
        />
        </Box>
      )}
    </Box>
  );
};

export default SelectCollectbyOffice;
